var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#136CFB",
    d: "M25,7.9c-0.7-1.5-1.6-2.9-2.8-4.1C21,2.6,19.6,1.7,18.1,1c-1.6-0.7-3.3-1-5.1-1S9.5,0.3,7.9,1 C6.4,1.7,5,2.6,3.8,3.8C2.6,5,1.7,6.4,1,7.9C0.3,9.5,0,11.2,0,13s0.3,3.5,1,5.1c0.7,1.5,1.6,2.9,2.8,4.1C5,23.4,6.4,24.3,7.9,25 c1.6,0.7,3.3,1,5.1,1c1.8,0,3.5-0.3,5.1-1c1.5-0.7,2.9-1.6,4.1-2.8c1.2-1.2,2.1-2.6,2.8-4.1c0.7-1.6,1-3.3,1-5.1S25.7,9.5,25,7.9z  M13,24.4c-2.7,0-5.1-0.9-7.1-2.5c1.1-3,3.9-5,7.1-5c3.2,0,6,2,7.1,5C18.1,23.4,15.7,24.4,13,24.4z M21.3,20.7 c-0.3-0.6-0.6-1.2-1-1.7c-0.6-0.8-1.2-1.4-2-2c-1.6-1.2-3.4-1.8-5.4-1.8c-2,0-3.8,0.6-5.4,1.8c-0.8,0.6-1.4,1.2-2,2 c-0.4,0.5-0.7,1.1-1,1.7c-1.9-2-3-4.7-3-7.7C1.6,6.7,6.7,1.6,13,1.6S24.4,6.7,24.4,13C24.4,16,23.2,18.7,21.3,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#136CFB",
    d: "M12.9,4.2c-1.4,0-2.6,0.5-3.6,1.5S7.8,7.9,7.8,9.3c0,1.4,0.5,2.6,1.5,3.6s2.2,1.5,3.6,1.5 c1.4,0,2.6-0.5,3.6-1.5S18,10.6,18,9.3c0-1.4-0.5-2.6-1.5-3.6S14.2,4.2,12.9,4.2z M12.9,12.9c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 s3.6,1.6,3.6,3.6S14.9,12.9,12.9,12.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4ebe0cbf.svg";
export { ForwardRef as ReactComponent };